import { motion } from 'framer-motion';

const PartnersSection = () => {
  // Logo URLs for partners that have logos
  const partnerLogos = {
    // Bakery Equipment
    'Mecnosud': '/logos/logo_mecnosud.webp',
    'MIWE': '/logos/logo_miwe.webp',
    // Bottle Coolers
    'Gamko': '/logos/logo_gamko.webp',
    'IMC': '/logos/logo_imc.webp',
    'Infrico': '/logos/logo_infrico.webp',
    'Tecfrigo': '/logos/logo_tecfrigo.webp',
    // Blenders
    'Hamilton Beach': '/logos/logo_hamiltonbeach.webp',
    'Vitamix': '/logos/logo_vitamix.webp',
    // Coffee Machine
    'Franke': '/logos/logo_franke.webp',
    'La Cimbali': '/logos/logo_lacimbali.avif',
    'WMF': '/logos/logo_wmf.webp',
    'Nuova Simonelli': '/logos/logo_nuovasimonelli.webp',
    // Cooking Equipment
    'Ambach': '/logos/logo_ambach.webp',
    'Angelo Po': '/logos/logo_angelopo.webp',
    'Bonnet': '/logos/logo_bonnet.webp',
    'Casta': '/logos/logo_casta.webp',
    'Charvet': '/logos/logo_charvet.webp',
    'Electrolux': '/logos/logo_electrolux.webp',
    'Falcon': '/logos/logo_falcon.webp',
    'Fujimak': '/logos/logo_fujimak.webp',
    'Henny Penny': '/logos/logo_hennypenny.webp',
    'MKN': '/logos/logo_mkn.webp',
    'Moffat': '/logos/logo_moffat.webp',
    'Pitco': '/logos/logo_pitco.avif',
    'Tecnoinox': '/logos/logo_tecnoinox.webp',
    'YPT International': '/logos/logo_YPT.webp',
    // Cooking Suite
    'Marrone': '/logos/logo_marrone.webp',
    'Molteni': '/logos/logo_molteni.webp',
    // Exhaust Hoods
    'Halton': '/logos/logo_halton.webp',
    'Vianen': '/logos/logo_vianen.webp',
    // Food & Drink Display
    'Counterline': '/logos/logo_counterline.webp',
    // Food Preparation
    'Fimar': '/logos/logo_fimar.webp',
    'KitchenAid': '/logos/logo_kitchenaid.webp',
    'Robot Coupe': '/logos/logo_robotcoupe.avif',
    'Sammic': '/logos/logo_sammic.webp',
    'Sirman': '/logos/logo_sirman.webp',
    // Food Service Equipment
    'Alto-Shaam': '/logos/logo_altoshaam.avif',
    'Cambro': '/logos/logo_cambro.webp',
    'Hatco': '/logos/logo_hatco.avif',
    'Hobart': '/logos/logo_hobart.webp',
    'Hupfer': '/logos/logo_hupfer.avif',
    'Prince Castle': '/logos/logo_princecastle.webp',
    'Roller Grill': '/logos/logo_rollergrill.webp',
    'Santos': '/logos/logo_santos.webp',
    'Tournus': '/logos/logo_tournos.webp',
    'Waring Commercial': '/logos/logo_waring.webp',
    // Glass & Dish Washers
    'Comenda': '/logos/logo_comenda.webp',
    'Meiko': '/logos/logo_meiko.webp',
    'Miele': '/logos/logo_miele.webp',
    'Winterhalter': '/logos/logo_winterhalter.webp',
    // Ice Cream & Gelato
    'Carpigiani': '/logos/logo_carpigiani.avif',
    'IFI': '/logos/logo_ifi.webp',
    // Ice Machine
    'Follett': '/logos/logo_follett.webp',
    'Hoshizaki': '/logos/logo_hoshizaki.webp',
    'Scotsman': '/logos/logo_scotsman.webp',
    // Induction Units
    'CookTek': '/logos/logo_cooktek.webp',
    'Spring': '/logos/logo_spring.webp',
    // Mixer Taps
    'Monolith': '/logos/logo_monolith.avif',
    'T&S': '/logos/logo_ts.webp',
    // Ovens
    'Alfa': '/logos/logo_alfa.webp',
    'Beech Ovens': '/logos/logo_beechovens.webp',
    'Menumaster': '/logos/logo_menumaster.webp',
    'Merrychef': '/logos/logo_merrychef.webp',
    'Moretti Forni': '/logos/logo_morettiforni.webp',
    'Rational': '/logos/logo_rational.webp',
    'Salva': '/logos/logo_salva.webp',
    'Stima': '/logos/logo_stima.webp',
    'TurboChef': '/logos/logo_turbochef.webp',
    'Unox': '/logos/logo_unox.webp',
    'Valoriani': '/logos/logo_valoriani.webp',
    'Xoven': '/logos/logo_xoven.avif',
    // Refrigerators & Freezers
    'Foster': '/logos/logo_foster.webp',
    'Frenox': '/logos/logo_frenox.webp',
    'Precision': '/logos/logo_precision.webp',
    'Studio 54': '/logos/logo_studio54.webp',
    'Williams': '/logos/logo_williams.webp',
    // Shelving
    'Metro': '/logos/logo_metro.avif',
    // Slicers
    'Berkel': '/logos/logo_berkel.webp',
    'NOAW': '/logos/logo_noaw.webp',
    // Vacuum Packing
    'Henkelman': '/logos/logo_henkelman.webp',
    // Hand Wash / Knife Sterilizer
    'Sofinor': '/logos/logo_sofinor.webp',
    'Tournus Equipement': '/logos/logo_tournos.webp',
    // Waste Bins
    'Rubbermaid': '/logos/logo_rubbermaid.webp',
    // Water Equipment
    'Marco': '/logos/logo_marco.webp',
    'Zip': '/logos/logo_zip.webp',
    'Everpure': '/logos/logo_everpure.webp',
    // White Goods
    'Bosch': '/logos/logo_bosch.webp',
    'Siemens': '/logos/logo_siemens.webp',
  };

  const partnerCategories = [
    { category: 'Bakery Equipment', partners: ['Mecnosud', 'MIWE'] },
    { category: 'Bottle Coolers', partners: ['Gamko', 'IMC', 'Infrico', 'Tecfrigo'] },
    { category: 'Blenders', partners: ['Hamilton Beach', 'Vitamix'] },
    { category: 'Coffee Machine', partners: ['Franke', 'La Cimbali', 'WMF', 'Nuova Simonelli'] },
    { category: 'Cooking Equipment', partners: ['Ambach', 'Angelo Po', 'Bonnet', 'Casta', 'Charvet', 'Electrolux', 'Falcon', 'Fujimak', 'Henny Penny', 'MKN', 'Moffat', 'Pitco', 'Tecnoinox', 'YPT International'] },
    { category: 'Cooking Suite', partners: ['Ambach', 'Charvet', 'Marrone', 'Molteni'] },
    { category: 'Exhaust Hoods', partners: ['Halton', 'Vianen'] },
    { category: 'Food & Drink Display', partners: ['Counterline', 'Infrico'] },
    { category: 'Food Preparation', partners: ['Fimar', 'KitchenAid', 'Robot Coupe', 'Sammic', 'Sirman'] },
    { category: 'Food Service Equipment', partners: ['Alto-Shaam', 'Cambro', 'Hatco', 'Hobart', 'Hupfer', 'Prince Castle', 'Roller Grill', 'Santos', 'Tournus', 'Waring Commercial'] },
    { category: 'Glass & Dish Washers', partners: ['Comenda', 'Meiko', 'Miele', 'Winterhalter'] },
    { category: 'Hand Wash / Knife Sterilizer', partners: ['Sofinor', 'Tournus Equipement'] },
    { category: 'Ice Cream & Gelato', partners: ['Carpigiani', 'IFI'] },
    { category: 'Ice Machine', partners: ['Follett', 'Hoshizaki', 'Scotsman'] },
    { category: 'Induction Units', partners: ['CookTek', 'Spring'] },
    { category: 'Mixer Taps / Shower Group', partners: ['Monolith', 'T&S'] },
    { category: 'Ovens', partners: ['Alfa', 'Beech Ovens', 'Menumaster', 'Merrychef', 'Moretti Forni', 'Rational', 'Salva', 'Stima', 'TurboChef', 'Unox', 'Valoriani', 'Xoven'] },
    { category: 'Refrigerators & Freezers', partners: ['Foster', 'Frenox', 'Infrico', 'Precision', 'Studio 54', 'Williams'] },
    { category: 'Shelving Unit', partners: ['Metro', 'Hupfer'] },
    { category: 'Slicers', partners: ['Berkel', 'NOAW'] },
    { category: 'Vacuum Packing', partners: ['Henkelman', 'Sammic'] },
    { category: 'Waste Bins', partners: ['Rubbermaid'] },
    { category: 'Hot Water Dispensers and Water Filters / Softeners', partners: ['Marco', 'Zip', 'Everpure'] },
    { category: 'White Goods', partners: ['Bosch', 'Siemens'] },
  ];

  const renderPartner = (partner, catIndex, partnerIndex) => {
    const hasLogo = partnerLogos[partner];
    
    if (hasLogo) {
      return (
        <motion.div
          key={partnerIndex}
          whileHover={{ scale: 1.05, y: -2 }}
          transition={{ duration: 0.3 }}
          className="p-3 bg-white border border-[#E5E0D5] hover:border-[#2C6E63] hover:shadow-md transition-all duration-300 flex items-center justify-center"
          data-testid={`partner-${catIndex}-${partnerIndex}`}
        >
          <img 
            src={hasLogo} 
            alt={partner} 
            className="h-8 md:h-10 w-auto object-contain max-w-[100px] grayscale-[30%] hover:grayscale-0 transition-all duration-500"
          />
        </motion.div>
      );
    }
    
    return (
      <span
        key={partnerIndex}
        className="px-3 py-2 bg-white text-[#2D3436] text-sm font-light tracking-wide border border-[#E5E0D5] hover:border-[#2C6E63] hover:text-[#2C6E63] transition-all duration-300 cursor-default"
        data-testid={`partner-${catIndex}-${partnerIndex}`}
      >
        {partner}
      </span>
    );
  };

  return (
    <section
      id="partners"
      className="py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-24"
      data-testid="partners-section"
    >
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-xs uppercase tracking-[0.3em] font-medium text-[#2C6E63] mb-4" data-testid="partners-overline">
            Our Partners
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl font-light tracking-tight text-[#2D3436] mb-6" data-testid="partners-heading">
            World-Class Equipment Partners
          </h2>
          <div className="w-16 h-px bg-[#D4C4A8] mx-auto mb-6"></div>
          <p className="text-[#6B6560] max-w-xl mx-auto font-light">
            Collaborating with industry-leading manufacturers to deliver excellence.
          </p>
        </motion.div>

        {/* Partners Grid - Always Open */}
        <div className="space-y-6">
          {partnerCategories.map((cat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.02 }}
              viewport={{ once: true }}
              className="bg-white border border-[#E5E0D5]"
              data-testid={`partner-category-${index}`}
            >
              {/* Category Header */}
              <div className="px-6 py-4 border-b border-[#E5E0D5] bg-[#F5F1EB]">
                <h3 
                  className="font-heading text-lg tracking-wide text-[#2D3436]"
                  data-testid={`partner-category-title-${index}`}
                >
                  {cat.category}
                </h3>
              </div>

              {/* Partners List - Always Visible */}
              <div className="px-6 py-5">
                <div className="flex flex-wrap gap-3 items-center">
                  {cat.partners.map((partner, partnerIndex) => 
                    renderPartner(partner, index, partnerIndex)
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
